export default "__VITE_ASSET__ChquWSbX__"